export default "__VITE_ASSET__BVsouX8T__"